import {CandidateSkill} from 'Interfaces'
import {orderBy} from 'lodash'

export const SortCandidateSkills = (items: CandidateSkill[]) =>
  orderBy(
    items,
    [(o) => o.skillLevel?.level, (o) => o.skill?.translation],
    ['desc', 'asc']
  )
